import {MessageViewModel} from './MessageViewModel';

export type SenderType = 'client' | 'server';

export class MessageGroupViewModel {
    constructor(public messages: MessageViewModel[], public sender: SenderType, public botAvatarImageUrl?: string) {
    }
}
